export default "__VITE_ASSET__C1VuE_4L__"